import { injectable } from 'tsyringe';
import type { TeamDataRepository } from '@/modules/statistics/domain/team/TeamDataRepository';
import { HttpClientApi } from '@/modules/http-client/public/api';
import type { QueryParams } from '@/modules/statistics/domain/QueryParams';
import type { TeamData } from '@/modules/statistics/domain/team/TeamData';

@injectable()
export class HttpTeamDataRepository implements TeamDataRepository {
  constructor(private readonly httpClient: HttpClientApi) {}

  get(queryParams: QueryParams): Promise<TeamData[]> {
    return this.httpClient.get('api/v0/facility/{facilityId}/stats/team', {
      ...queryParams,
    });
  }
}
